import React from 'react';
import NavigationTokens from '../../../../Shared/constants/navigationTokens';
import NavTokenMapService from '../../../../Shared/services/navTokenMapService';
import ConfigPropId from '../../../../Shared/constants/configPropId';
import ConfigPropMapService from '../../../../Shared/services/configPropMapService';

class HelpLinks extends React.PureComponent {
    constructor(props, context) {
        super(props, context);
        const enableResponsiveSdsSearch = ConfigPropMapService.getConfigPropbyId(ConfigPropId.EnableResponsiveSdsSearch).value;

        this.shoppingAndBrowsingLinks = [{ navTokenName: NavigationTokens.FindaProduct, title: "Find a Product" },
        { navTokenName: NavigationTokens.CreateAnOrder },
        { navTokenName: NavigationTokens.CreateaShoppingList, title: "Create a Shopping List" },
        { navTokenName: NavigationTokens.ItemType, title: "Item Type & Color Legend" }];

        this.placingYourOrderLinks = [{ navTokenName: NavigationTokens.PaymentMethods },
        { navTokenName: NavigationTokens.SalesTax },
        { navTokenName: NavigationTokens.ShippingInformation },
        { navTokenName: NavigationTokens.CompletingYourOrder }];

        this.generalInformationLinks = [{ navTokenName: NavigationTokens.FAQs, title: "FAQs" },
        { navTokenName: NavigationTokens.OnlineSecurity },
        { navTokenName: NavigationTokens.WebAccessibility },
        { navTokenName: NavigationTokens.SafetyDataSheets, title: "SDS Search", vNextPageName: enableResponsiveSdsSearch ? `sds-search` : "" }];

        this.policiesLinks = [{ navTokenName: NavigationTokens.PrivacyPolicy },
        { navTokenName: NavigationTokens.TermsOfUse },
        { navTokenName: NavigationTokens.ReturnsPolicy, title: "Return Policy" }];
    }

    getNavTokenListItem(navToken, overridenTitle, vNextPageName) {
        let token = NavTokenMapService.getNavToken(navToken).url;
        let titleSplitByCaps = navToken.split(/(?=[A-Z])/);
        titleSplitByCaps = titleSplitByCaps.join(' ');

        return <a href={vNextPageName ? `${reactConfigObject.baseVNextUrl}/${vNextPageName}` : token}>{overridenTitle ? overridenTitle : titleSplitByCaps}</a>;
    }

    renderHelpLinksColumn(header, navTokenList) {
        return <div className="grid-link">
            <span><b>{header}</b></span>
            <ul>
                {navTokenList.map((x, index) => <li key={index}>{this.getNavTokenListItem(x.navTokenName, x.title, x.vNextPageName)}</li>)}
            </ul>
        </div>;
    }

    render() {
        return (
            <div className="contact-us-row help-links">
                {this.renderHelpLinksColumn("Shopping And Browsing", this.shoppingAndBrowsingLinks)}
                <div className="icon-divider" />
                {this.renderHelpLinksColumn("Placing Your Order", this.placingYourOrderLinks)}
                <div className="icon-divider" />
                {this.renderHelpLinksColumn("General Information", this.generalInformationLinks)}
                <div className="icon-divider" />
                {this.renderHelpLinksColumn("Policies", this.policiesLinks)}
            </div>
        );
    }
}

export default HelpLinks;
